// src/App.js
import React from 'react';
import JobTracker from './JobTracker';

const App = () => {
  return (
    <div className="App">
      <JobTracker />
    </div>
  );
};

export default App;
